// extracted by mini-css-extract-plugin
module.exports = {"dialogBody":"style_dialogBody__2KneQ","formGroupMargin":"style_formGroupMargin__2aDWJ","dialog":"style_dialog__3l7jZ","dialogBackDrop":"style_dialogBackDrop__24tww"};